module.exports = __webpack_public_path__ + "static/media/data-view-icon.d236f06f.svg";